

























import Vue from 'vue';
import ModalBase from '@/components/util/ModalBase.vue';
// import ModalBase from '@/components/util/ModalBaseV3.vue'; //REMOLABO-402

export default Vue.extend({
  name: 'ModalInputBase',
  components: { ModalBase},
  props: {
    title: String,
    okButton: String,
    okButtonSp: String,
    cancelButton: String,
    cancelButtonSp: String,
  },
  data() {
    return {};
  },
  methods: {
    onClickOK() {
      this.$emit('ok');
    },
    onClickClose() {
      this.$emit('close');
    },
  },
});
